import { Component, OnInit } from '@angular/core';
import {NotificationsService} from '../notifications.service';
import {CookieService} from 'ngx-cookie';
import {Notifications} from '../notifications.enum';
import {UserService} from '../../../shared/user.service';
import {
	GLOBAL_NOTIFICATION_TYPE,
	GlobalNotificationsService
} from '../../../core/components/global-notifications/global-notifications.service';
import * as moment from 'moment';

@Component({
	selector: 'tt-unapproved-days-off-requests-notification',
	templateUrl: './unapproved-days-off-requests.component.html',
	styleUrls: ['./unapproved-days-off-requests.component.scss']
})
export class UnapprovedDaysOffRequestsNotificationComponent implements OnInit {

	unapprovedDaysOffRequests: any[] = [];

	constructor(private notificationsService: NotificationsService,
				private cookieService: CookieService,
				private userService: UserService,
				private globalNotificationsService: GlobalNotificationsService
	) { }

	ngOnInit(): void {
		this.updateDaysOffRequests();

		this.notificationsService.dayOffApproved$
			.subscribe(() => {
				this.updateDaysOffRequests();
				this.globalNotificationsService.sendNotification(GLOBAL_NOTIFICATION_TYPE.SUCCESS, 'Day off approved', 5000);
			});
	}

	updateDaysOffRequests(): void {
		this.notificationsService
			.getUnapprovedDayOffRequests()
			.map((ranges: any[]) => ranges.sort((a: any, b: any) => a.dates[0].date - b.dates[0].date))
			.subscribe((ranges: any[]) => {
				this.unapprovedDaysOffRequests = ranges;
			});
	}

	isVisible(): boolean {
		const cookieVisible: boolean = this.cookieService.getObject(NotificationsService.cookieNameFromType(Notifications.UNAPPROVED_DAYS_OFF)) !== false;
		return this.isAdmin() && this.dataPresent() && cookieVisible;
	}

	closeNotification(): void {
		this.notificationsService.closeNotification(Notifications.UNAPPROVED_DAYS_OFF);
	}

	approveDayOffRequest(range: any): void {
		this.notificationsService.approveDayOffRequest(range);
	}

	isPartialDayOffRange(range: any): boolean {
		return this.notificationsService.isPartialDaysOffRange(range);
	}

	private dataPresent(): boolean {
		return this.unapprovedDaysOffRequests && this.unapprovedDaysOffRequests.length > 0;
	}

	formatDayOffDate(timestamp: any, format: string): string {
		return moment.utc(timestamp).format(format);
	}

	private isAdmin(): boolean {
		if (this.userService.user) {
			return this.userService.user.ttAdmin;
		}
		return false;
	}

}



// WEBPACK FOOTER //
// ./src/app/my-time/notifications/unapproved-days-off-requests/unapproved-days-off-requests.component.ts